import React from 'react';

const Copyright = (): React.ReactElement => <span>© {new Date().getFullYear()} Bo Ingram</span>;

export default Copyright;
